
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Standard_Completed_Non_Winner = class Notification_Standard_Completed_Non_Winner {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    $modal() {
        return $("#ac-modal-standard-completed-non-winner-modal");
    }

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let that = this;

        let meta;
        let bid_id = null;
        let round_id = null;
        let item_id = null;

        try {
            meta = JSON.parse(this.notification.meta)
            bid_id = meta.bid_id;
            round_id = meta.round_id;
            item_id = meta.item_id;

        } catch (e) {
        }

        if (!_.Notification_Standard_Completed_Non_Winner.denied_modal_init) {
            _.Notification_Standard_Completed_Non_Winner.denied_modal_init = true;
            $("#ac-modal-standard-completed-non-winner-close").click(function (e) {
                e.preventDefault();
                _.Modal.close_unhidable();
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                let round = await App_Models_AuctionRound.fetch(round_id);
                let item = await App_Models_AuctionItem.fetch(item_id);
                if (!round || !item) {
                    return;
                }

                $("#ac-modal-standard-completed-non-winner-tract-number").text(item.lot_number);
                $("#ac-modal-standard-completed-non-winner-tract-name").text(item.title);

                let deferred = $.Deferred();

                that.$modal().data('deferred', deferred);

                that.$modal().modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
    }
}